import React from 'react'

const Employee = ({classes , setEmploye , employee}) => {

    const handleCheckEmployeChange =(e)=>{
        const isChecked =e.target.checked
        const checkedId = e.target.id;
      setEmploye((prevstate)=>{
        if(isChecked){
          return [...prevstate , {id:checkedId, type:"employe" }]
        }else{
          return prevstate.filter((item)=>(item.id !==checkedId))
        }
      })
      }

  return (
    <div className={classes.collapseContent} >
    <input
      type="checkbox"
      id={employee.id}
      onChange={handleCheckEmployeChange}
      className={classes.checkBoxCustom}
    />
    <label htmlFor={employee.id} className={classes.employeLabel}>
      {employee.name_en}
    </label>
  </div>
  )
}

export default Employee